import * as TYPES from '@app/store/actionTypes';
import { setupTemplateByDraft, TemplateAction } from '@app/store/template/actions';

type TemplateTitleState = string;

const initialState: TemplateTitleState = '';

export default function reducer(state: TemplateTitleState = initialState, action: TemplateAction) {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
      return initialState;
    case TYPES.TEMPLATE_CREATE__PDF_LOAD_SUCCESS:
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS:
    case setupTemplateByDraft.type:
      return action.payload.title;
    case TYPES.TEMPLATE_TITLE_CHANGE:
      return action.payload.value;
    default:
      return state;
  }
}
